export default "__VITE_ASSET__IODRBAVH__"